export interface QuickFilters {
  section: QuickFiltersSection[];
}

export interface QuickFiltersSection {
  sectionName: string;
  list: QuickFiltersList[];
}

export interface QuickFiltersList {
  display: string;
  quickFilterType: QuickFilterType;
  queryBody: any;
  title: string;
}

export enum QuickFilterType {
  TASK_LIST_VIEW = 'TASK_LIST_VIEW',
  REFERRAL_VIEW = 'REFERRAL_VIEW',
}
